<div class="header-main-user" (click)="toggleUserMenu()">
    <core-helper-navigation-user-menu-header [open]="!closed"
        [user]="session.current.user"></core-helper-navigation-user-menu-header>
</div>

<div class="header-dropdown"  *ngIf="show" [ngClass]="{'dropmenu-opened': !closed, 'dropmenu-closed': (closed&&initialized)}" > 
    <div class="nav-dropdown">
        <strong class="arrow-shadow"><em>Select</em></strong>

        <ul *ngIf="menu.length > 0">
            <li *ngFor="let m of menu" class="tw2-dropdown-nav-li {{m.class}}">
                <a *ngIf="m.href; else internalLink" [href]="m.href" target="_blank" rel="noopener" (click)="closeMenu()">{{m.name}}</a>
                <ng-template #internalLink>
                    <a [routerLink]="[m.link]" (click)="itemMobileAction()">{{m.name}}</a>
                </ng-template>
            </li>
        </ul>
        <ul *ngIf="showSwitchApp">
            <li class="tw2-dropdown-nav-li tw2-switch-app">
                <span (click)="openApps()">
                    Apps
                </span>
            </li>
        </ul>
        <ul *ngIf="showChangeOrg">
            <li class="tw2-dropdown-nav-li tw2-change-org">
                <span (click)="changeOrg()">
                    Change Organization
                </span> 
            </li>
        </ul>
        <ul>
            <li class="tw2-dropdown-nav-li tw2-drop-sign-out tw2-action-logout">
                <span (click)="logout($event)">Sign out</span>
            </li>
        </ul>
      
    </div>
</div>